import { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import LocalizedStrings from 'react-localization';
import LOCALIZATIONS from './localizations';
import './style.css';
import { SET_NAME } from '../../redux/actions/board';
import Revision from './Revision'
import { updateTitle } from '../../util/title';

const BoardName = ({ disabled, source }) => {

    const classNames = [ 'coe__boardName' ],
    dispatch = useDispatch(),
    labels = useMemo(() => new LocalizedStrings( LOCALIZATIONS ), []),
    locale = useSelector( state => state.app.locale ),
    { dragging, name, isNew, revision, fork } = useSelector( state => state.board );

    /**
     * @name onChange
     * @function
     * @description Handles the key up function of the input box
     * @param {HTMLElement} target 
     */
    const onChange = ({ target }) => {
        dispatch({ type: SET_NAME, payload: target.value });
    }

    // update locale
    useEffect(() => {
        if( locale !== labels.getLanguage() ) labels.setLanguage( locale )
    }, [ labels, locale ]);

    // update the page title
    useEffect(() => {
        updateTitle( source?.name || name  );
    }, [ source, name ]);

    if( isNew && !disabled ) return null;

    if( disabled ) classNames.push( classNames[ 0 ] + '--disabled' );
    if( dragging ) classNames.push( classNames[ 0 ] + '--dragging' );

    return (
        <>
            <div className={ classNames.join( ' ' ) }>
                <input 
                    className="coe__boardName__input"
                    disabled={ disabled }
                    onChange={ onChange }
                    placeholder={ labels.boardName }
                    value={ source?.name || name || '' } />
            </div>
            <Revision labels={ labels } revision={ source?.revision || revision } tokenId={ source?.fork?.tokenId || fork?.tokenId } name={ source?.fork?.name || fork?.name } />
        </>
    )

};

BoardName.propTypes = {
    disabled: PropTypes.bool,
    source: PropTypes.shape({
        name: PropTypes.string,
        revision: PropTypes.number,
        forkedFrom: PropTypes.number
    })
}

export default BoardName;